import { DnsConfigResolver } from './core/resolver/dns-config.resolver';
import { Routes } from '@angular/router';
import { canActivate } from './modules/cross-profile/authentication/auth-guard.service';
import { SettingsComponent } from './modules/cross-profile/settings/settings.component';

export const routes: Routes = [
    { path: '', redirectTo: 'cockipit', pathMatch: 'full' },
    {
        path: '',
        canActivate: [canActivate],
        resolve: { theme: DnsConfigResolver },
        loadChildren: () =>
            import('./modules/company/main/main-company.module').then(
                (mod) => mod.MainCompanyModule
            ),
    },
    {
        path: '',
        canActivate: [canActivate],
        data: {
            onlyFinsteinUsers: true,
        },
        loadChildren: () =>
            import(
                './modules/administration/main/main-administration.module'
            ).then((mod) => mod.MainAdministrationModule),
    },
    {
        path: 'settings',
        canActivate: [canActivate],
        component: SettingsComponent,
        loadChildren: () =>
            import('./modules/cross-profile/settings/settings.module').then(
                (m) => m.SettingsModule
            ),
    },
    {
        path: 'authentication',
        resolve: { theme: DnsConfigResolver },
        loadChildren: () =>
            import(
                './modules/cross-profile/authentication/authentication.module'
            ).then((m) => m.AuthenticationModule),
    },
    {
        path: 'imprint',
        loadChildren: () =>
            import(
                './modules/public/internal-pages/imprint/imprint.module'
            ).then((m) => m.ImprintModule),
    },
    {
        path: 'privacy',
        loadChildren: () =>
            import(
                './modules/public/internal-pages/privacy/privacy.module'
            ).then((m) => m.PrivacyModule),
    },
    {
        path: 'notification-settings',
        loadChildren: () =>
            import(
                './modules/public/email-notification-management/email-notification-management.module'
            ).then((m) => m.EmailNotificationManagement),
    },
    {
        path: 'validation',
        loadChildren: () =>
            import(
                './modules/company/company-responsible-validator/company-responsible-validator.module'
            ).then((m) => m.CompanyResponsibleValidatorModule),
    },
    { path: '**', redirectTo: 'authentication', pathMatch: 'full' },
];
